import React, { createContext, useContext, useEffect, useState } from "react";
import { api, saveToken, clearToken, hasToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!hasToken()) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => clearToken())
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    saveToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (email, password, name, referral_code) => {
    const r = await api.post("/auth/register", { email, password, name, referral_code });
    saveToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => { clearToken(); setUser(null); };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
